import MobileDetect from 'mobile-detect';
import KeenTracking from 'keen-tracking';

import config from 'config';

class KeenIO {
  constructor() {
    this.md = new MobileDetect(window.navigator.userAgent);

    this._init();
  }

  _init() {
    this.client = new KeenTracking({
      projectId: config.KEEN_PROJECT_ID,
      writeKey: config.KEEN_WRITE_KEY,
    });
    this.helpers = KeenTracking.helpers;
    this.utils = KeenTracking.utils;
    this.sessionCookie = this.utils.cookie('vs_tracking');

    if (!this.sessionCookie.get('visit_id')) {
      this.sessionCookie.set('visit_id', this.helpers.getUniqueId());
    }
  }

  track(campaign_id, design_id, utm) {
    let payload = {
      geo: { ip_address: '${keen.ip}', info: {} },
      page: { title: document.title, url: document.location.href, info: { /* Enriched */ } },
      referrer: { url: document.referrer, info: { /* Enriched */ } },
      tech: { browser: this.helpers.getBrowserProfile(), user_agent: '${keen.user_agent}', info: { /* Enriched */ } },
      visitor: { visit_id: this.sessionCookie.get('visit_id') /* Include additional visitor info here */ },
      keen: {
        addons: [
          { name: 'keen:ip_to_geo', input: { ip: 'geo.ip_address' }, output: 'geo.info' },
          { name: 'keen:ua_parser', input: { ua_string: 'tech.user_agent' }, output: 'tech.info' },
          { name: 'keen:url_parser', input: { url: 'page.url' }, output: 'page.info' },
          { name: 'keen:referrer_parser', input: { referrer_url: 'referrer.url', page_url: 'page.url' }, output: 'referrer.info' },
          { name: 'keen:date_time_parser', input: { date_time: 'keen.timestamp' }, output: 'time.utc' },
        ]
      },
      custom: {
        device: this.md.tablet() ? 'tablet' : this.md.mobile() ? 'mobile' : 'desktop',
        ...utm.toParams(),
      },
    };

    if (campaign_id) payload.custom.campaign_id = campaign_id;
    if (design_id) payload.custom.design_id = design_id;

    this.client.extendEvents(() => payload);

    this.client.recordEvent('pageviews');
  }

  upsell(campaign_id, design_id, trigger_cid) {
    let payload = {
      geo: { ip_address: '${keen.ip}', info: {} },
      page: { title: document.title, url: document.location.href, info: { /* Enriched */ } },
      referrer: { url: document.referrer, info: { /* Enriched */ } },
      tech: { browser: this.helpers.getBrowserProfile(), user_agent: '${keen.user_agent}', info: { /* Enriched */ } },
      visitor: { visit_id: this.sessionCookie.get('visit_id') /* Include additional visitor info here */ },
      keen: {
        addons: [
          { name: 'keen:ip_to_geo', input: { ip: 'geo.ip_address' }, output: 'geo.info' },
          { name: 'keen:ua_parser', input: { ua_string: 'tech.user_agent' }, output: 'tech.info' },
          { name: 'keen:url_parser', input: { url: 'page.url' }, output: 'page.info' },
          { name: 'keen:referrer_parser', input: { referrer_url: 'referrer.url', page_url: 'page.url' }, output: 'referrer.info' },
          { name: 'keen:date_time_parser', input: { date_time: 'keen.timestamp' }, output: 'time.utc' },
        ]
      },
      custom: {
        device: this.md.tablet() ? 'tablet' : this.md.mobile() ? 'mobile' : 'desktop',
        campaign_id,
        design_id,
        trigger_cid,
      },
    };

    this.client.extendEvents(() => payload);

    this.client.recordEvent('upsell');
  }

  get id() {
    return this.sessionCookie.get('visit_id');
  }
};

export default new KeenIO();